import { createRef } from 'react';

export const OVERVIEW = {
  section: 'overview',
  textKey: 'property_show.content_navigation.overview'
};

export const REVIEWS = {
  section: 'reviews',
  textKey: 'property_show.content_navigation.reviews',
  flag: 'hasReviews'
};

export const HOUSE_RULES = {
  section: 'landlordRules',
  textKey: 'property_show.content_navigation.landlord_rules'
};

export const SURROUNDINGS = {
  section: 'surroundings',
  textKey: 'property_show.content_navigation.surroundings',
  flag: 'hasSurroundings'
};

export const HOW_TO_BOOK = {
  section: 'howToBook',
  textKey: 'property_show.content_navigation.howToBook'
};

export const PRICING = {
  section: 'pricing',
  textKey: 'listing.pricing.title.standalone',
  hideOnFlag: 'isRoomsAggregator'
};

export const CANCELLATION_POLICIES = {
  section: 'cancellationPolicies',
  textKey: 'property_show.content_navigation.cancellation_policies'
};

export const AVAILABILITIES = {
  section: 'availabilities',
  textKey: 'listing.availabilities.title',
  hideOnFlag: 'isListingSimplificationBottomVariant'
};

export const LANDLORD_INFORMATION = {
  section: 'aboutLandlord',
  textKey: 'property_show.content_navigation.landlord_information'
};

export const ITEMS = [
  OVERVIEW,
  REVIEWS,
  CANCELLATION_POLICIES,
  HOUSE_RULES,
  LANDLORD_INFORMATION,
  HOW_TO_BOOK,
  PRICING,
  AVAILABILITIES,
  SURROUNDINGS
];

export const getNavigationItems = (flags = {}) => {
  return ITEMS.filter(item => !item.flag || flags[item.flag])
    .filter(item => !item.hideOnFlag || !flags[item.hideOnFlag])
    .filter(item => !flags.hidePricingSection || item.section !== 'pricing')
    .map(item => ({ data: item, ref: createRef() }));
};

export default {
  getNavigationItems
};
